import { createFileRoute } from '@tanstack/react-router'

import { UsersScreen } from '@/features/admin'
import { optional, z } from '@/lib/utils/search-params'

const usersSearch = z.object({
  q: optional(z.string().check(z.maxLength(100))),
  state: optional(z.enum(['active', 'disabled', 'locked'])),
})

export const Route = createFileRoute('/_auth/admin/users')({
  validateSearch: usersSearch,
  component: UsersRoute,
})

function UsersRoute() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <UsersScreen
      search={search}
      onSearchChange={(patch) => void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: true })}
    />
  )
}
